// Shared map/measuring behaviour for sections/lawn-measuring-tool.liquid.
// Runs once per page load and initialises every instance of the section found
// on the page. Per-instance merchant settings (API key, default map centre,
// colours, copy) are read from the section's own data-lawn-config JSON
// attribute rather than being hardcoded into this shared file.
(() => {
  const roots = document.querySelectorAll('.lawn-measure-section');
  if (!roots.length) return;

  roots.forEach((root) => {
    if (root.dataset.lawnInitialised === 'true') return;
    root.dataset.lawnInitialised = 'true';

    let config = {};
    try {
      config = JSON.parse(root.dataset.lawnConfig || '{}');
    } catch (error) {
      config = {};
    }

    const apiKey = config.apiKey || '';
    const sectionId = root.id.replace(/^lawn-measure-/, '');

    const startButton = root.querySelector('[data-lawn-start]');
    const startPanel = root.querySelector('[data-lawn-start-panel]');
    const toolPanel = root.querySelector('[data-lawn-tool]');
    const addressInput = root.querySelector('[data-lawn-address]');
    const searchButton = root.querySelector('[data-lawn-search]');
    const clearButton = root.querySelector('[data-lawn-clear]');
    const undoButton = root.querySelector('[data-lawn-undo]');
    const areaOutput = root.querySelector('[data-lawn-area]');
    const mapEl = document.getElementById('lawn-map-' + sectionId);

    if (!startButton || !startPanel || !toolPanel || !addressInput || !mapEl) return;

    let map;
    let geocoder;
    let polygon;
    let markers = [];
    let points = [];
    let mapReady = false;

    const defaultCentre = {
      lat: Number(config.defaultLat) || 52.4862,
      lng: Number(config.defaultLng) || -1.8904
    };

    function loadGoogleMaps(callback) {
      if (window.google && window.google.maps && window.google.maps.geometry) {
        callback();
        return;
      }

      const existingScript = document.querySelector('script[data-lawn-google-maps="true"]');
      const callbackName = 'lawnMapsLoaded';

      window[callbackName] = function() {
        callback();
      };

      if (existingScript) return;

      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&libraries=geometry&loading=async&callback=' + callbackName;
      script.async = true;
      script.defer = true;
      script.dataset.lawnGoogleMaps = 'true';
      document.head.appendChild(script);
    }

    function initMap() {
      if (mapReady) return;
      mapReady = true;

      geocoder = new google.maps.Geocoder();

      map = new google.maps.Map(mapEl, {
        center: defaultCentre,
        zoom: Number(config.defaultZoom) || 18,
        mapTypeId: 'satellite',
        tilt: 0,
        streetViewControl: false,
        mapTypeControl: true,
        fullscreenControl: true,
        clickableIcons: false
      });

      polygon = new google.maps.Polygon({
        map: map,
        paths: [],
        strokeColor: config.polygonStroke || '#ffffff',
        strokeWeight: 3,
        strokeOpacity: 1,
        fillColor: config.polygonFill || '#ffffff',
        fillOpacity: 0.38,
        clickable: false
      });

      map.addListener('click', function(event) {
        addPoint(event.latLng);
      });

      updateArea();
    }

    function addPoint(latLng) {
      points.push(latLng);
      renderAll();
    }

    function renderAll() {
      renderPolygon();
      renderMarkers();
      updateArea();
    }

    function renderPolygon() {
      if (!polygon) return;

      if (points.length >= 3) {
        polygon.setOptions({
          paths: points,
          visible: true
        });
      } else {
        polygon.setOptions({
          paths: [],
          visible: false
        });
      }
    }

    function renderMarkers() {
      markers.forEach(function(marker) {
        marker.setMap(null);
      });

      markers = [];

      points.forEach(function(point, index) {
        const marker = new google.maps.Marker({
          position: point,
          map: map,
          draggable: true,
          clickable: true,
          title: 'Point ' + (index + 1)
        });

        marker.addListener('drag', function(event) {
          points[index] = event.latLng;
          renderPolygon();
          updateArea();
        });

        marker.addListener('dragend', function(event) {
          points[index] = event.latLng;
          renderPolygon();
          updateArea();
        });

        marker.addListener('click', function() {
          points.splice(index, 1);
          renderAll();
        });

        markers.push(marker);
      });
    }

    function updateArea() {
      if (!areaOutput) return;

      if (!points || points.length < 3) {
        areaOutput.textContent = config.resultDefault || '';
        return;
      }

      const areaM2 = google.maps.geometry.spherical.computeArea(points);
      const roundedArea = Math.round(areaM2);

      areaOutput.textContent = roundedArea.toLocaleString('en-GB') + ' m²';
    }

    function searchAddress() {
      const address = addressInput.value.trim();
      if (!address || !geocoder) return;

      geocoder.geocode({ address: address }, function(results, status) {
        if (status === 'OK' && results[0]) {
          map.setCenter(results[0].geometry.location);
          map.setZoom(Number(config.searchZoom) || 20);
        } else {
          alert(config.addressErrorText || 'Address not found. Please try again.');
        }
      });
    }

    function clearMap() {
      points = [];
      renderAll();
    }

    function undoPoint() {
      if (!points.length) return;
      points.pop();
      renderAll();
    }

    startButton.addEventListener('click', function() {
      if (!apiKey) {
        alert('Please add your Google Maps API key in the section settings.');
        return;
      }

      startPanel.hidden = true;
      toolPanel.hidden = false;

      loadGoogleMaps(function() {
        initMap();
        setTimeout(function() {
          google.maps.event.trigger(map, 'resize');
          map.setCenter(defaultCentre);
        }, 100);
      });
    });

    if (searchButton) searchButton.addEventListener('click', searchAddress);
    if (clearButton) clearButton.addEventListener('click', clearMap);
    if (undoButton) undoButton.addEventListener('click', undoPoint);

    addressInput.addEventListener('keydown', function(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        searchAddress();
      }
    });
  });
})();
